import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { FaArrowUp } from 'react-icons/fa';

// Small floating action button that fades in once the visitor has scrolled
// past the hero, and smooth-scrolls back to the top when clicked.
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.25 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <Link to="header" smooth duration={500}>
            <motion.button
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Back to top"
              className="flex items-center justify-center w-11 h-11 rounded-full bg-accent-green text-forest shadow-lg shadow-accent-green/30 hover:bg-accent-green/90 transition-colors cursor-pointer"
            >
              <FaArrowUp />
            </motion.button>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
